import { ApiChainSymbols, ApiCurrencySymbols } from './enums';

export const currencyOrder = [
  ApiCurrencySymbols.SUI,
  ApiCurrencySymbols.EGLD,
  ApiCurrencySymbols.DASH,
  ApiCurrencySymbols.USDT,
  ApiCurrencySymbols.USDC,
  ApiCurrencySymbols.POL,
  ApiCurrencySymbols.ETH,
  ApiCurrencySymbols.BTC,
];

export const blockchainOrder = [
  ApiChainSymbols.ERD,
  ApiChainSymbols.POLYGON,
  ApiChainSymbols.TRX,
  ApiChainSymbols.ETH,
  ApiChainSymbols.SOL,
  ApiChainSymbols.BTC,
];
